import { Skill } from "@/v2/entities/skill/Skill.model";

export interface Instruction {
  content: string;
  subTopic: string | null;
  topic: string | null;
  type:
    | "general"
    | "manual"
    | "brief"
    | "knowledge"
    | "isEnabled"
    | "prerequisite"
    | "global-instructions";
  source?: string;
  enabled?: boolean;
  createdAt?: string | Date;
}

export interface ManualInstruction {
  content: string;
  subTopic: string | null;
  topic: string;
  type: "manual";
}

export interface KnowledgeInstruction extends Instruction {
  type: "knowledge";
  source: string;
  enabled: boolean;
}

export interface Release {
  id: number;
  simulatorId: number;
  releasePolicy: string;
  filterPolicy?: string;
  tenantId: string;
  status: ReleaseStatus;
  publishedAt?: string;
  createdAt?: string;
  updatedAt?: string;
  gradualRolloutEnabled?: boolean;
  gradualRolloutPercentage?: number;
  releaseConditions: ReleaseCondition[];
  conversations: ReleaseConversation[];
  skills?: Skill[];
  customToneOfVoice?: string;
}

export interface SimulatorReleaseLite {
  id: number;
  createdAt?: string | Date;
  status: ReleaseStatus;
  releasePolicy: string | Instruction[];
  publishedAt?: string | Date;
}

export interface ReleaseCondition {
  id: number;
  releaseId: number;
  tenantId: string;
  conditionType: ConditionType;
  conditionValue: string;
  createdAt: Date;
  updatedAt: Date;
}

export interface ReleaseConversation {
  id: number;
  releaseComments: ReleaseComment[];
  releaseId?: number;
  topicId?: number;
  tenantId: string;
  feedback: ReleaseConversationFeedback;
  feedbackComment?: string;
  createdAt: Date;
  updatedAt: Date;
}

export interface ReleaseComment {
  id: number;
  isAgent: boolean;
  comment: string;
  releaseConversationId?: number;
  tenantId: string;
  createdAt: Date;
  updatedAt: Date;
}

export enum ReleaseConversationFeedback {
  POSITIVE = "POSITIVE",
  NEGATIVE = "NEGATIVE",
  NONE = "NONE",
}

export enum ReleaseStatus {
  draft = "draft",
  published = "published",
}

export enum ConditionType {
  TYPE_A = "TYPE_A",
  TYPE_B = "TYPE_B",
}

export enum ReleaseResourceAccessStatus {
  FULL_ACCESS = 'FULL_ACCESS',
  NO_ACCESS = 'NO_ACCESS',
  LIMITED_ACCESS = 'LIMITED_ACCESS',
}

export enum Topic {
  TOPIC_A = "TOPIC_A",
  TOPIC_B = "TOPIC_B",
}

export type TTopic = {
  id: number;
  name?: string;
  topic: string;
  owner: string;
  tenant: string;
  enabledPolicies: string[];
  description?: string;
};

export type Rule = {
  id: string;
  field: string;
  operator: string;
  value: string[];
};

export type FilterGroup = {
  id: string;
  combinator: "and" | "or";
  rules: Rule[];
};
